import { connect } from 'react-redux'

import { ASCENT_FILTER_MAX, ASCENT_FILTER_MIN, DISTANCE_FILTER_MAX, DISTANCE_FILTER_MIN } from '../../settings'
import { bikeTypesList, surfacesList } from '@bikemap/js/integrations/routes/helpers'
import { RouteFilters } from '../presentational'
import { updateFilters } from '../../actions'
import { UNIT } from '../../../../settings'

const config = {
    unit: UNIT,
    minDistance: DISTANCE_FILTER_MIN,
    maxDistance: DISTANCE_FILTER_MAX,
    distanceScale: [50, 100],
    minAscent: ASCENT_FILTER_MIN,
    maxAscent: ASCENT_FILTER_MAX,
    ascentScale: [500, 1000],
    categoryOptions: bikeTypesList,
    surfaceOptions: surfacesList,
}

/** @param {import("../../store").SearchState} state */
const mapStateToProps = ({ filters }) => ({ filters, config })

const mapDispatchToProps = dispatch => ({
    onChange: updatedFilters => dispatch(updateFilters(updatedFilters)),
})

export default connect(mapStateToProps, mapDispatchToProps)(RouteFilters)
